import React, {Component} from 'react'

import Registry from '../../../registry/index';

class ChatLogItemTip extends Component {

    constructor(props) {
        super(props);

    }

    onAuthorLeftClick(event, user) {
        event.preventDefault();
        event.persist();
        
        this.props.openVideoWindow(user.ufrag);
    }

    onAuthorRightClick(event, user) {
        event.preventDefault();
        event.persist();

        this.props.showUserContextMenu(event, user);
    }

    componentDidMount() {
        if(this.itemElement) {
            let mentions = this.itemElement.querySelectorAll('.mention');

            let callback = function (mention) {
                for (let event in this.mentionEvents) {
                    mention.addEventListener(event, this.mentionEvents[event])
                }
            };

            if (typeof mentions.forEach == 'function') {
                mentions.forEach(callback, this)
            } else {
                Array.prototype.forEach.call(mentions, callback, this); // old IE workaround
            }
        }
    }

    componentWillUnmount() {
        if(this.itemElement) {
            let mentions = this.itemElement.querySelectorAll('.mention');

            let callback = function (mention) {
                for (let event in this.mentionEvents) {
                    mention.removeEventListener(event, this.mentionEvents[event])
                }
            };

            if (typeof mentions.forEach == 'function') {
                mentions.forEach(callback, this);
            } else {
                Array.prototype.forEach.call(mentions, callback, this); // old IE workaround
            }
        }
    }

    render() {
        let {message, currentUser} = this.props;

        let sender = message.senderUser;
        let receiver = message.receiverUser;
        let receiver_nick = message.receiver;

        if (!sender) return null;

        let lang = Registry.get('locale');

        let senderBlock = (
            <span
                className={`sender ${sender.nick === currentUser.nick ? 'mention-me' : 'mention'}`}
                onClick={(event) => this.onAuthorLeftClick(event, sender)}
                onContextMenu={(event) => this.onAuthorRightClick(event, sender)}
            >{sender.nick}</span>
        );
        let receiverBlock = (
            <span
                className={`receiver ${receiver_nick === currentUser.nick ? 'mention-me' : 'mention'}`}
                onClick={(event) => receiver ? this.onAuthorLeftClick(event, receiver) : false}
                onContextMenu={(event) => receiver ? this.onAuthorRightClick(event, receiver) : false}
            >{receiver_nick}</span>
        );

        let bg = "";

        if(message.amount < 5) {
            bg = "";
        } else if(message.amount < 10) {
            bg = "bg1";
        } else if(message.amount < 20) {
            bg = "bg2";
        } else if(message.amount < 50) {
            bg = "bg3";
        } else if(message.amount < 100) {
            bg = "bg4";
        } else if(message.amount < 200) {
            bg = "bg5";
        } else if(message.amount < 500) {
            bg = "bg6";
        } else if(message.amount < 1000) {
            bg = "bg7";
        } else {
            bg = "bg8";
        }

        return (
            <div className="tip-notification" ref={(ref) => this.itemElement = ref}>
                <div className="icon-plus-one"><div className={bg}><div className="amount">+{message.amount}</div></div></div>
                <div className="text">
                    {senderBlock} {lang.give_tokens_to(message.amount)} {receiverBlock}
                </div>
            </div>
        )
    }

}

export default ChatLogItemTip;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemTip/index.js